import React, { useEffect, useState } from 'react';
import { deleteUploads, fetchData, save } from '../../services/stacks';
import { exhibitIndexFileName } from '../../lib/constants';
import './style.scss';

const SaveButton = ({ isDraft, setIsDraft, value, fileName, title, setOpenSnackBar, setErrorMsg }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [fileNaming, setFileNaming] = useState('');
  const [updateDate, setUpdateDate] = useState('');
  const [chiming, setChiming] = useState(false);


  const handleClick = () => {
    setShowMenu(!showMenu);
  };

  const handleClose = () => {
    setShowMenu(false);
  };

  const saveExhibitAndIndex = async () => {
    let mdFileName = `${Date.now()}.md`, content = value, lastUpdated = new Date().toISOString(), chimed = false;
    // fetch existing index's
    let existingIndex = await fetchData(`${exhibitIndexFileName}?t=${new Date().getTime()}`, { decrypt: false });
    existingIndex = existingIndex.success ? existingIndex.result : null;

    if (existingIndex[fileName || fileNaming]) {
      // This chunk of code updates both Exhibit Md and the Exhibit Index files
      const { status, fileName: filename } = existingIndex[fileName || fileNaming];
      let existingExhibitMd = await fetchData(filename, { decrypt: status === "Draft" ? true : false });
      if (existingExhibitMd?.success) {
        const { fileName: originName } = existingExhibitMd.result;
        const updateExhibit = (await save({ fileName: originName, content: JSON.stringify({ ...existingExhibitMd.result, content, title, lastUpdated }) })).success;
        let updateIndex = existingIndex;
        updateIndex[fileName || fileNaming] = { ...updateIndex[fileName || fileNaming], ...{ title, lastUpdated, status: "Draft" } };
        updateIndex = (await save({ fileName: exhibitIndexFileName, content: JSON.stringify(updateIndex) }, { encrypt: false })).success;
        return (updateExhibit && updateIndex);
      }
      return false;
    } else {
      // This chunk of code creates a brand new exhibit
      const createExhibit = (await save({ fileName: mdFileName, content: JSON.stringify({ title, fileName: mdFileName, content, lastUpdated, chimed, status: 'Draft' }) }, { encrypt: true })).success;
      let updateIndex = existingIndex;
      updateIndex = { [mdFileName]: { title, lastUpdated, fileName: mdFileName, status: "Draft" }, ...updateIndex };
      updateIndex = (await save({ fileName: exhibitIndexFileName, content: JSON.stringify(updateIndex) }, { encrypt: false })).success;
      if (createExhibit && updateIndex) {
        setFileNaming(mdFileName);
        setUpdateDate(lastUpdated);
        setChiming(chimed);
      }
      return (createExhibit && updateIndex);
    }
  };

  const updateExhibitAndIndex = async () => {
    // fetch existing index's
    let existingIndex = await fetchData(`${exhibitIndexFileName}?t=${new Date().getTime()}`, { decrypt: false });
    existingIndex = existingIndex.success ? existingIndex.result : null;




    if (existingIndex[fileNaming || fileName]) {
      let getMdFile;
      if (fileNaming) { getMdFile = { content: value, lastUpdated: updateDate, title, fileName: fileNaming, chimed: chiming, status: 'Published' }; }
      if (fileName) {
        getMdFile = (await fetchData(`${existingIndex[fileNaming || fileName].fileName}?t=${new Date().getTime()}`, { decrypt: existingIndex[fileNaming || fileName].status === "Draft" ? true : false }));
        getMdFile = getMdFile.success ? getMdFile.result : null;
        if (getMdFile) getMdFile.status = "Published";
      }

      let updateMdFile = (await save({ fileName: fileNaming || fileName, content: JSON.stringify(getMdFile) }, { encrypt: false })).success;
      existingIndex[fileNaming || fileName].status = "Published";
      const updateIndex = (await save({ fileName: exhibitIndexFileName, content: JSON.stringify(existingIndex) }, { encrypt: false })).success;
      return updateMdFile && updateIndex;
    }
    return false;
  }

  async function onSaveDraft() {
    if (!title || !value) {
      setErrorMsg({ msg: 'Title is required.', severity: 'error' });
      setOpenSnackBar(true);
      return
    }
    const result = await saveExhibitAndIndex();
    if (result) {
      setErrorMsg({ msg: 'Exhibit saved and indexed successfully!', severity: 'success' });
    } else {
      setErrorMsg({ msg: 'Exhibit changes not saved!!', severity: 'error' });
    }
    setOpenSnackBar(true);
  }

  async function onPublish() {
    const result = await updateExhibitAndIndex();
    if (result) {
      setErrorMsg({ msg: 'Title published successfully', severity: 'success' });
    } else {
      setErrorMsg({ msg: 'Title not found in existing index', severity: 'error' });
    }
    setOpenSnackBar(true);
  }

  async function reset() {
    save({ fileName: exhibitIndexFileName, content: JSON.stringify({}) }, { encrypt: false }).then(res => {
      if (res.success) {
        setErrorMsg({ msg: 'done', severity: 'success' });
      } else {
        setErrorMsg({ msg: "failed", severity: "error" });
      }
      setOpenSnackBar(true);
    })
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button disabled={isDraft} className='save-exhibit-button' onClick={handleClick} >
        Save Exhibit
      </button>
      {/* <button onClick={reset}>Reset</button> */}
      {showMenu && (
        <div className='save-exhibit-button-menu'>
          <div className='save-exhibit-button-menuitem' onClick={() => { onSaveDraft(); handleClose(); }}>
            💾 Save as Draft (Private)
          </div>
          <div className='save-exhibit-button-menuitem' onClick={() => { onPublish(); handleClose(); }}>
            🚀 Publish to Profile (Public)
          </div>
        </div>
      )}
    </div>
  );
};

export default SaveButton;
